import ComplainItem from "./ComplainItem";
import TanksItem from "./TanksItem";
import CommentItem from "./CommentItem";

const ComplainTypeLoader = (props) => {
    const { data } = props;

    if (data.type === "complain") return <ComplainItem {...props} />;
    if (data.type === "thanks") return <TanksItem {...props} />;
    return <CommentItem {...props} />;
};

export default ComplainTypeLoader;
